import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import it from './locales/it.json'
import de from './locales/de.json'
import no from './locales/no.json'
import pt from './locales/pt.json'
import ptBR from './locales/pt-BR.json'
import ru from './locales/ru.json'
import ro from './locales/ro.json'
import zh from './locales/zh.json'
import id from './locales/id.json'
import vi from './locales/vi.json'
import th from './locales/th.json'
import ka from './locales/ka.json'
import my from './locales/my.json'

const defaultLang = import.meta.env.VITE_DEFAULT_LANGUAGE ?? 'en'
const persistedLang = (() => {
  try {
    return localStorage.getItem('i18n_language')
  } catch {
    return null
  }
})()

i18n.use(initReactI18next).init({
  lng: persistedLang ?? defaultLang,
  fallbackLng: 'en',
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    it: { translation: it },
    de: { translation: de },
    no: { translation: no },
    pt: { translation: pt },
    'pt-BR': { translation: ptBR },
    ru: { translation: ru },
    ro: { translation: ro },
    zh: { translation: zh },
    id: { translation: id },
    vi: { translation: vi },
    th: { translation: th },
    ka: { translation: ka },
    my: { translation: my },
  },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
})

export default i18n
